import { required, maxLength, numeric, minValue } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    quantidadeDigitos: { required, numeric, minValue: minValue(1), maxLength: maxLength(2) },
    tempoEspera: { required, numeric },
    quantidadeLoops: { required, numeric },
    audioPesquisa: { required },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Campo obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Não pode conter mais de 30 caracteres.')
    return errors
  },
  quantidadeDigitosErrors() {
    const errors = []
    if (!this.$v.form.quantidadeDigitos.$dirty) return errors
    !this.$v.form.quantidadeDigitos.required && errors.push('Campo obrigatório.')
    !this.$v.form.quantidadeDigitos.numeric && errors.push('Apenas caracteres numéricos.')
    !this.$v.form.quantidadeDigitos.minValue && errors.push('Valor mínimo: 1.')
    !this.$v.form.quantidadeDigitos.maxLength && errors.push('Não pode conter mais de 2 dígitos.')
    return errors
  },
  tempoEsperaErrors() {
    const errors = []
    if (!this.$v.form.tempoEspera.$dirty) return errors
    !this.$v.form.tempoEspera.required && errors.push('Campo obrigatório.')
    !this.$v.form.tempoEspera.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  quantidadeLoopsErrors() {
    const errors = []
    if (!this.$v.form.quantidadeLoops.$dirty) return errors
    !this.$v.form.quantidadeLoops.required && errors.push('Campo obrigatório.')
    !this.$v.form.quantidadeLoops.numeric && errors.push('Apenas caracteres numéricos.')
    return errors
  },
  audioPesquisaErrors() {
    const errors = []
    if (!this.$v.form.audioPesquisa.$dirty) return errors
    !this.$v.form.audioPesquisa.required && errors.push('Campo obrigatório.')
    return errors
  },
}
